import { cn } from '@/lib/utils'
import {
Tooltip,
TooltipContent,
TooltipProvider,
TooltipTrigger,
} from '@/components/ui/tooltip'

interface PrinterStatusIndicatorProps {
  status: string | null | undefined
  isActive?: boolean
  className?: string
}

export function PrinterStatusIndicator({
  status,
  isActive = true,
  className,
}: PrinterStatusIndicatorProps) {
  const isOnline = status === 'ONLINE'
  const label = isOnline ? 'Online' : 'Offline'
  const activeLabel = isActive ? '' : ' (Inactive)'

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'w-2 h-2 rounded-full shrink-0 cursor-help',
              isOnline ? 'bg-green-500' : 'bg-gray-300',
              !isActive && 'opacity-50 grayscale',
              className
            )}
          />
        </TooltipTrigger>
        <TooltipContent side="top" align="center">
          {label}{activeLabel}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
